import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=2bebcf34&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=ts"
export * from "./OurStory.vue?vue&type=script&lang=ts"
import style0 from "./OurStory.vue?vue&type=style&index=0&id=2bebcf34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bebcf34",
  null
  
)

export default component.exports